import BaseURL from '../../assets/contants/BaseURL';

const RECONNECT_DELAY_MS = 3000;

function wsUrlFor(path, meterId) {
    const token = sessionStorage.getItem('token') || '';
    const wsBase = BaseURL.replace(/^http/, 'ws');
    return `${wsBase}${path}/${encodeURIComponent(meterId)}/?token=${encodeURIComponent(token)}`;
}

function createSocketRegistry(path) {
    const connections = new Map();

    function openSocket(meterId, entry) {
        if (entry.closed) return;

        const ws = new WebSocket(wsUrlFor(path, meterId));
        entry.ws = ws;

        ws.onmessage = (event) => {
            try {
                const snapshot = JSON.parse(event.data);
                entry.latest = snapshot;
                entry.listeners.forEach((cb) => cb(snapshot));
            } catch (err) {
                console.error(`meterSocket(${path}): failed to parse message`, err);
            }
        };

        ws.onclose = () => {
            if (entry.closed || entry.refCount === 0) return;
            entry.reconnectTimer = setTimeout(() => openSocket(meterId, entry), RECONNECT_DELAY_MS);
        };

        ws.onerror = () => {
            ws.close();
        };
    }

    function ensureConnection(meterId) {
        let entry = connections.get(meterId);
        if (entry) return entry;

        entry = { ws: null, refCount: 0, listeners: new Set(), latest: null, reconnectTimer: null, closed: false };
        connections.set(meterId, entry);
        openSocket(meterId, entry);
        return entry;
    }

    function getLatest(meterId) {
        return connections.get(meterId)?.latest ?? null;
    }

    function subscribe(meterId, callback) {
        const entry = ensureConnection(meterId);
        entry.refCount += 1;
        entry.listeners.add(callback);

        if (entry.latest) callback(entry.latest);

        return function unsubscribe() {
            entry.listeners.delete(callback);
            entry.refCount -= 1;
            if (entry.refCount <= 0) {
                entry.closed = true;
                if (entry.reconnectTimer) clearTimeout(entry.reconnectTimer);
                if (entry.ws) entry.ws.close();
                connections.delete(meterId);
            }
        };
    }

    return { subscribe, getLatest };
}

const snapshotRegistry = createSocketRegistry('meters/dashboard');
export const subscribeMeter = snapshotRegistry.subscribe;
export const getLatestSnapshot = snapshotRegistry.getLatest;

const historyRegistry = createSocketRegistry('meters/dashboard-chart');
export const subscribeMeterHistory = historyRegistry.subscribe;
export const getLatestHistorySnapshot = historyRegistry.getLatest;

const tableRegistry = createSocketRegistry('meters/dashboard-table');
export const subscribeMeterTable = tableRegistry.subscribe;
export const getLatestTableSnapshot = tableRegistry.getLatest;
